import { render, staticRenderFns } from "./awards-2022.vue?vue&type=template&id=21ea376a&scoped=true&"
import script from "./awards-2022.vue?vue&type=script&lang=js&"
export * from "./awards-2022.vue?vue&type=script&lang=js&"
import style0 from "./awards-2022.vue?vue&type=style&index=0&id=21ea376a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea376a",
  null
  
)

export default component.exports